import PageLayout from "../components/PageLayout";
import CtaBand from "../components/CtaBand";
import { Eyebrow, Reveal } from "../components/Reveal";
import { AvailabilityCalendar } from "../components/AvailabilityCalendar";
import { breadcrumb } from "../components/Seo";

const PATH = "/availability/";
const SEO = {
  title: "Availability | Private Island Dates in Clew Bay — Collanmore Island Lodge",
  description:
    "Check live availability for Collanmore Island Lodge — exclusive-use private island accommodation in Clew Bay, Westport, County Mayo. Booked and provisional dates shown.",
  path: PATH,
  jsonLd: [breadcrumb(PATH, "Availability")],
};

export default function AvailabilityPage() {
  return (
    <PageLayout seo={SEO}>
      <main className="bg-navy pb-24 pt-36 md:pt-44" data-testid="availability-page">
        <div className="mx-auto max-w-[1200px] px-5 md:px-10">
          <Reveal>
            <Eyebrow light>Availability</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="mt-6 max-w-3xl font-display text-4xl font-medium leading-tight text-ivory md:text-6xl" data-testid="page-h1">
              Choose your days on the island
            </h1>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-2xl text-sm font-light leading-relaxed text-ivory/75 md:text-base">
              One island. One group. This calendar follows the lodge&rsquo;s own booking diary — confirmed bookings,
              provisional holds and maintenance days included. Departure days stay open for the next group&rsquo;s
              arrival.
            </p>
          </Reveal>

          <div className="mt-12">
            <AvailabilityCalendar months={12} />
          </div>
        </div>
      </main>
      <CtaBand
        eyebrow="Your dates are free?"
        heading="Enquire now and hold them"
        lead="An enquiry never commits you — tell us the dates and the occasion, and we will confirm availability and price personally."
        cta="Check Availability"
      />
    </PageLayout>
  );
}